module.exports = __webpack_public_path__ + "img/cbf0d3c16de385d69185deb18247564.b2ed9c1f.png";